<template>
  <div class="LKMunMehFormHeader">
    <v-layout>
      <v-tabs
        v-model="currentPage"
        hide-slider
        center-active
        height="36px"
        background-color="#00000000"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
          :value="tab.key"
          :loading="loading"
          :disabled="loading"
          v-text="tab.text"
        />
      </v-tabs>
      <v-spacer />
      <v-btn
        color="primary"
        rounded
        outlined
        @click="onClose"
        v-text="'Закрыть'"
      />
    </v-layout>
  </div>
</template>

<script>
import MunMehHeaderMixin from '@/views/LKMunMeh/mixins/MunMehHeaderMixin'

export default {
  name: 'LKMunMehFormHeader',
  mixins: [MunMehHeaderMixin],
}
</script>

<style scoped lang="scss">
.LKMunMehFormHeader {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  .ml-btn {
    margin-left: 12px;
  }
}
</style>
